import React from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
import { caseStudies } from '../data/caseStudies';

const CaseStudyPage = () => {
  const { slug } = useParams();
  const { language } = useLanguage();
  const { theme } = useTheme();
  
  const study = caseStudies.find(study => study.slug === slug);
  
  if (!study) return <div>Case study not found</div>;

  return (
    <article className={`py-16 px-4 ${theme === "dark" ? "bg-gray-900" : "bg-white"}`}>
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <img 
            src={study.imageUrl} 
            alt={language === "en" ? study.titleEn : study.titleFr}
            className="w-full h-[400px] object-cover rounded-lg"
          />
        </div>
        
        <span className={`text-sm font-semibold ${
          theme === "dark" ? "text-green-500" : "text-green-600"
        }`}>
          {language === "en" ? study.categoryEn : study.categoryFr}
        </span>
        
        <h1 className={`text-4xl font-bold mt-4 mb-6 ${
          theme === "dark" ? "text-white" : "text-gray-900"
        }`}>
          {language === "en" ? study.titleEn : study.titleFr}
        </h1>
        
        <div className="mb-8 text-sm text-gray-500">
          {new Date(study.date).toLocaleDateString(
            language === "en" ? "en-US" : "fr-FR",
            { year: 'numeric', month: 'long', day: 'numeric' }
          )}
        </div>
        
        <div className={`prose max-w-none ${
          theme === "dark" 
            ? "prose-invert prose-green" 
            : "prose-green"
        }`}>
          {language === "en" 
            ? <div dangerouslySetInnerHTML={{ __html: study.contentEn }} />
            : <div dangerouslySetInnerHTML={{ __html: study.contentFr }} />
          }
        </div>
      </div>
    </article>
  );
};

export default CaseStudyPage; 